import { ResidentialUnitExtraData } from '@/types';
import { sortBy } from 'lodash-es';

// export interface GroupedResidentialUnits {
//     id: number | null;
//     name: string;
//     units: ResidentialUnitExtraData[];
// }

// export function groupResidentialUnits(units: ResidentialUnitExtraData[]) {
//     const groupMap = new Map<number | null, GroupedResidentialUnits>();

//     units.forEach((u) => {
//         let group = groupMap.get(u.residentialUnitGroupId);

//         if (!group) {
//             group = { id: u.residentialUnitGroupId, name: u.residentialUnitGroupName ?? '', units: [] };
//             groupMap.set(group.id, group);
//         }

//         group.units.push(u);
//     });

//     groupMap.values().forEach((g) => {
//         g.units = sortBy(g.units, (x) => x.name);
//     });

//     return sortBy([...groupMap.values()], (x) => x.name);
// }

export interface GroupedResidentialUnits<T = ResidentialUnitExtraData> {
    id: number | null;
    name: string;
    units: T[];
}

export function groupResidentialUnits<T>(
    units: T[],
    getter: (x: T) => ResidentialUnitExtraData
): GroupedResidentialUnits<T>[] {
    const groupMap = new Map<number | null, GroupedResidentialUnits<T>>();
    units.forEach((x) => {
        const u = getter(x);
        let group = groupMap.get(u.residentialUnitGroupId);

        if (!group) {
            group = { id: u.residentialUnitGroupId, name: u.residentialUnitGroupName ?? '', units: [] };
            groupMap.set(group.id, group);
        }

        group.units.push(x);
    });
    [...groupMap.values()].forEach((g) => {
        g.units = sortBy(g.units, (x) => getter(x).name);
    });

    return sortBy([...groupMap.values()], (x) => x.name);
}
